import { defineStore } from "pinia";
import { ref, onMounted, watch } from 'vue';
import { carregarTurmas, carregarEstudantes, carregarNotasDosAlunos, carregarAvaliacoesInfo, carregarDisciplinas } from "@/api/fetchDadosBasicos";
import calcularMediaParaAlunoComAvaliacoes from "@/utils/calcularMediaPorAlunoComAvaliacoes";
import calcularRiscoReprovacao from "@/utils/calcularRiscoReprovacao";


export const useResumoDesempenhoStore = defineStore('resumoDesempenho', () => {
    const loading = ref(false);
    const turmas = ref([]);
    const turmaSelecionada = ref(null);
    const estudantes = ref([]);
    const disciplinas = ref([]);


    onMounted(async () => {
        loading.value = true;
        turmas.value = await carregarTurmas();
        disciplinas.value = await carregarDisciplinas();
        loading.value = false;
    })

    watch(turmaSelecionada, async () => {
        if(turmaSelecionada.value == null){
            estudantes.value = []
            return
        }
        loading.value = true;
        let dados = await carregarEstudantes(turmaSelecionada.value.id);
        estudantes.value = dados.map((estudante) => {
            return {
                ...estudante,
                notasHumanas: [],
                notasLinguagens: [],
                notasMatematica: [],
                notasNatureza: []
            }
        })
        
        let notas = await carregarNotasDosAlunos(estudantes.value.map(estudante => estudante.id));


        let idsAvaliacoes = [];
        notas.forEach(aluno => {
            if(!idsAvaliacoes.includes(aluno.avaliacao)){
                idsAvaliacoes.push(aluno.avaliacao)
            }
        })


        let dadosDasAvaliacoes = await carregarAvaliacoesInfo(idsAvaliacoes);
        dadosDasAvaliacoes.forEach(avaliacao => {
            let area = disciplinas.value.find(disciplina => disciplina.id == avaliacao.disciplina);
            avaliacao.idArea = area.id_area
        })


        notas.forEach(nota => {
            let avaliacao = dadosDasAvaliacoes.find(avaliacao => avaliacao.id == nota.avaliacao);
            nota.infoAvaliacao = avaliacao;
        })

        estudantes.value.forEach(estudante => {
            let notasAluno = notas.filter(nota => nota.estudante == estudante.id);
            estudante.notasHumanas = notasAluno.filter(nota => nota.infoAvaliacao.idArea == 1);
            estudante.notasLinguagens = notasAluno.filter(nota => nota.infoAvaliacao.idArea == 4);
            estudante.notasMatematica = notasAluno.filter(nota => nota.infoAvaliacao.idArea == 2);
            estudante.notasNatureza = notasAluno.filter(nota => nota.infoAvaliacao.idArea == 3);
            estudante.mediaHumanas = calcularMediaParaAlunoComAvaliacoes(estudante.notasHumanas);
            estudante.mediaLinguagens = calcularMediaParaAlunoComAvaliacoes(estudante.notasLinguagens);
            estudante.mediaMatematica = calcularMediaParaAlunoComAvaliacoes(estudante.notasMatematica);
            estudante.mediaNatureza = calcularMediaParaAlunoComAvaliacoes(estudante.notasNatureza);
            estudante.riscoReprovacao = calcularRiscoReprovacao(estudante.mediaHumanas, estudante.mediaLinguagens, estudante.mediaMatematica, estudante.mediaNatureza);
            estudante.notasMaiorQueZero = notasAluno.filter(nota => nota.nota > 0).length;
        })

        console.log(estudantes.value)
    
        loading.value = false;

    })





    return {loading, turmas, turmaSelecionada, estudantes};
});